import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitEditUserData = createAsyncThunk(
  "submitEditUser/fetchEditSubmitUser",
  async ({ stationId, userId, payload }) => {
    const facilityID = JSON.parse(window.localStorage.getItem("selectedStation") || "null");
    try {
      const response = await api.post(
        `prometheus/${facilityID?.id}/${userId}/user/edit/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitEditUserSlice = createSlice({
  name: "submitEditUser",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitEditUserData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitEditUserData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitEditUserData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default SubmitEditUserSlice.reducer;
